import React, { useState,  useContext , useEffect } from 'react';
import { AuthContext } from '../AuthContext';
import {useNavigate } from 'react-router-dom';
import Login from './Login';
import s from '../styles/Home.module.css';
import PolicyModal from './orders/PolicyModal'; // путь проверь
import OfertaModal from './orders/OfertaModal'; // путь проверь

function Home() {
  const { currentUser, loading, fetchCurrentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isRegistering, setIsRegistering] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);
  const [showOferta, setShowOferta] = useState(false);

  useEffect(() => {
    if (!loading && currentUser) {
        const { tg_user_id, tgsecretkey } = currentUser || {};
      
      if (tgsecretkey && tg_user_id) {
        console.log('home to dashboard');
        fetchCurrentUser();
        navigate("/dashboard");
      }
    }
  }, [currentUser, navigate, loading,]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const referrer_code = params.get('ref');
    const offer_id = params.get('ofid');
  
    if (referrer_code) document.cookie = `referrer_code=${referrer_code}; path=/; max-age=2592000`;
    if (offer_id) document.cookie = `offer_id=${offer_id}; path=/; max-age=2592000`;
  }, []);

  return (
    <div className={s.home_container}>
      <div  className={s.switch_forms_div_to_center}>
        <div className={s.switch_forms_div}>
            <div className={s.auth_switcher}>
              <button
                onClick={() => setIsRegistering(false)}
                className={!isRegistering ? s.active : s.noactive}
              >
                Вход
              </button>
            </div>
            
            <div className={s.auth_form}>
               <Login />
            </div>
        </div>
      </div>


    </div>
  );
}

export default Home;
